import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    '@keyframes auditChartCardIn': {
        '0%': {
            opacity: 0,
            transform: 'translateY(8px)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    '@keyframes auditChartLineDraw': {
        '0%': {
            strokeDashoffset: 1400,
        },
        '100%': {
            strokeDashoffset: 0,
        },
    },
    '@keyframes auditChartFadeIn': {
        '0%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    '@keyframes auditDonutIn': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.86)',
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1)',
        },
    },
    header: {
        background: '#CEDDFF',
        borderBottom: '1px solid #4D80C9',
        display: 'flex',
        alignItems: 'center',
        minHeight: '49px',
        padding: '0px 0px 0 15px',
    },
    pageContent: {
        background: '#F5FAFD',
        boxSizing: 'border-box',
        maxWidth: '100%',
        minHeight: 'calc(100vh - 131px)',
        overflowX: 'hidden',
        padding: '22px 58px 30px',
        [theme.breakpoints.down('md')]: {
            padding: '18px 24px 28px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '14px 12px 24px',
        },
    },
    filterBar: {
        background: '#FFFFFF',
        border: '1px solid #D8E2EB',
        borderRadius: '18px',
        boxShadow: '0 1px 1px rgba(15, 35, 56, 0.02)',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px',
        width: '100%',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
            height: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#CBD8E4',
            borderRadius: '8px',
        },
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            overflowX: 'visible',
        },
    },
    filterPill: {
        minHeight: '40px',
        minWidth: '160px',
        border: '1px solid #D8E2EB',
        borderRadius: '11px',
        background: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        padding: '6px 11px',
        flex: '1 0 160px',
        maxWidth: '186px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 'none',
            flex: '1 1 190px',
        },
    },
    clickableFilterPill: {
        appearance: 'none',
        cursor: 'pointer',
        font: 'inherit',
        margin: 0,
        outline: 'none',
        textAlign: 'left',
        transition: 'border-color 160ms ease, box-shadow 160ms ease, background 160ms ease',
        '&:hover': {
            background: '#F9FCFF',
            borderColor: '#BFD2E2',
        },
        '&:focus-visible': {
            borderColor: '#4D80C9',
            boxShadow: '0 0 0 2px rgba(77, 128, 201, 0.14)',
        },
        '&:disabled': {
            cursor: 'default',
            opacity: 0.7,
        },
    },
    filterIcon: {
        color: '#687B8F',
        fontSize: '17px',
        flexShrink: 0,
    },
    filterText: {
        minWidth: 0,
    },
    filterLabel: {
        color: '#617187',
        fontFamily: 'Lato',
        fontSize: '10px',
        fontWeight: 700,
        lineHeight: '12px',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
    },
    filterValue: {
        color: '#102033',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    filterArrow: {
        color: '#63758A',
        fontSize: '18px',
        flexShrink: 0,
        marginLeft: 'auto',
    },
    filterMenuPaper: {
        border: '1px solid #D8E2EB',
        borderRadius: '11px',
        boxShadow: '0 10px 30px rgba(15, 35, 56, 0.12)',
        marginTop: '6px',
        minWidth: '190px',
        overflow: 'hidden',
    },
    filterMenuItem: {
        color: '#142133',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 600,
        minHeight: '34px',
        padding: '7px 13px',
        '&.Mui-selected': {
            background: '#EAF4FF',
            color: '#193A63',
            fontWeight: 800,
        },
        '&.Mui-selected:hover': {
            background: '#E0F0FF',
        },
    },
    customRangePaper: {
        border: '1px solid #D8E2EB',
        borderRadius: '13px',
        boxShadow: '0 12px 32px rgba(15, 35, 56, 0.14)',
        marginTop: '6px',
        overflow: 'hidden',
        width: '328px',
        [theme.breakpoints.down('xs')]: {
            width: 'calc(100vw - 28px)',
        },
    },
    customRangeContent: {
        background: '#FFFFFF',
        padding: '14px',
    },
    customRangeTitle: {
        color: '#142133',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 800,
        lineHeight: '18px',
        marginBottom: '12px',
    },
    customRangeFields: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
        },
    },
    customDateField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            fontFamily: 'Lato',
            fontSize: '13px',
            '& fieldset': {
                borderColor: '#D8E2EB',
            },
            '&:hover fieldset': {
                borderColor: '#BFD2E2',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#4D80C9',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#617187',
            fontFamily: 'Lato',
            fontSize: '12px',
            fontWeight: 700,
        },
    },
    filterDateField: {
        flex: '1 0 160px',
        maxWidth: '190px',
        '& .MuiInputBase-root': {
            minHeight: '40px',
            background: '#FFFFFF',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: 'none',
            flex: '1 1 190px',
        },
    },
    customRangeError: {
        color: '#C24141',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '16px',
        marginTop: '9px',
    },
    customRangeActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
        marginTop: '14px',
    },
    customRangeCancelButton: {
        background: '#FFFFFF',
        color: '#102033',
        border: '1px solid #D8E2EB',
        borderRadius: '10px',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 800,
        minHeight: '34px',
        padding: '6px 12px',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
            background: '#F7FAFD',
        },
    },
    customRangeApplyButton: {
        background: '#193A63',
        color: '#FFFFFF',
        borderRadius: '10px',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 800,
        minHeight: '34px',
        padding: '6px 14px',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
            background: '#102D50',
            color: '#FFFFFF',
        },
    },
    searchPill: {
        minHeight: '40px',
        minWidth: '218px',
        border: '1px solid #D8E2EB',
        borderRadius: '11px',
        background: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '6px 10px',
        flex: '1.2 0 218px',
        [theme.breakpoints.down('sm')]: {
            flex: '1 1 240px',
        },
    },
    searchIcon: {
        color: '#607286',
        fontSize: '18px',
        flexShrink: 0,
    },
    searchInput: {
        color: '#102033',
        fontFamily: 'Lato',
        fontSize: '13px',
        width: '100%',
        '& input': {
            padding: 0,
            '&::placeholder': {
                color: '#52657A',
                opacity: 1,
            },
        },
    },
    applyButton: {
        background: '#193A63',
        color: '#FFFFFF',
        borderRadius: '11px',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 700,
        minHeight: '40px',
        minWidth: '108px',
        padding: '7px 15px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        '&:hover': {
            background: '#102D50',
            color: '#FFFFFF',
        },
        '& .MuiButton-startIcon': {
            marginRight: '6px',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '17px',
        },
    },
    resetButton: {
        background: '#FFFFFF',
        color: '#102033',
        border: '1px solid #D8E2EB',
        borderRadius: '11px',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 700,
        minHeight: '40px',
        minWidth: '78px',
        padding: '7px 13px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        '&:hover': {
            background: '#F7FAFD',
            color: '#102033',
        },
        '& .MuiButton-startIcon': {
            marginRight: '6px',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    exportButton: {
        background: '#249A9C',
        color: '#FFFFFF',
        borderRadius: '11px',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 700,
        minHeight: '40px',
        minWidth: '92px',
        padding: '7px 14px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        '&:hover': {
            background: '#188486',
            color: '#FFFFFF',
        },
        '&.Mui-disabled': {
            background: '#B7DCDD',
            color: '#FFFFFF',
        },
        '& .MuiButton-startIcon': {
            marginRight: '6px',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    summaryHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        margin: '28px 0 12px',
    },
    summaryHeaderIcon: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: '#183A62',
        color: '#FFFFFF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    summaryTitle: {
        color: '#132234',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 800,
        lineHeight: '18px',
    },
    summaryDate: {
        color: '#6E7F91',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
            width: '100%',
        },
    },
    summaryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(150px, 1fr))',
        gap: '9px',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'repeat(2, minmax(140px, 1fr))',
        },
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
        },
    },
    summaryCard: {
        minHeight: '58px',
        border: '1px solid',
        borderRadius: '11px',
        display: 'flex',
        alignItems: 'center',
        gap: '11px',
        padding: '10px 13px',
        overflow: 'hidden',
    },
    cardIcon: {
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    cardValue: {
        color: '#102033',
        fontFamily: 'Lato',
        fontSize: '18px',
        fontWeight: 800,
        lineHeight: '20px',
        marginBottom: '2px',
    },
    cardLabel: {
        color: '#526274',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '15px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    insightsSection: {
        marginTop: '14px',
        background: '#EAF8FF',
        border: '1px solid #BDE2F1',
        borderRadius: '18px',
        overflow: 'hidden',
        paddingBottom: '12px',
    },
    insightsHeader: {
        minHeight: '40px',
        background: '#DDF4FF',
        borderBottom: '1px solid #C5E4F1',
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        padding: '9px 16px',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            flexWrap: 'wrap',
        },
    },
    insightsHeaderIcon: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: '#1B93B0',
        color: '#FFFFFF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    insightsTitle: {
        color: '#0987A8',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 800,
        lineHeight: '18px',
    },
    insightsSubtitle: {
        color: '#6A7A8D',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            paddingLeft: '31px',
        },
    },
    chartCard: {
        background: '#FFFFFF',
        border: '1px solid #D4E3EC',
        borderRadius: '14px',
        margin: '12px 12px 0',
        padding: '12px 12px 14px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 rgba(15, 35, 56, 0.02)',
    },
    chartCardEnter: {
        animation: '$auditChartCardIn 520ms ease-out both',
        willChange: 'opacity, transform',
    },
    chartDelayOne: {
        animationDelay: '40ms',
    },
    chartDelayTwo: {
        animationDelay: '140ms',
    },
    chartCardHeader: {
        marginBottom: '8px',
    },
    chartTitle: {
        color: '#142133',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 800,
        lineHeight: '17px',
        '& .MuiSvgIcon-root': {
            color: '#1888C8',
            fontSize: '15px',
        },
    },
    chartSubtitle: {
        color: '#657689',
        fontFamily: 'Lato',
        fontSize: '11px',
        fontWeight: 500,
        lineHeight: '15px',
        marginTop: '5px',
    },
    lineChartWrap: {
        height: '180px',
        minWidth: 0,
        '& .recharts-wrapper': {
            fontFamily: 'Lato',
        },
    },
    lineChartAnimated: {
        '& .recharts-cartesian-grid, & .recharts-xAxis, & .recharts-yAxis': {
            animation: '$auditChartFadeIn 520ms ease-out 280ms both',
        },
        '& .recharts-line-curve': {
            strokeDasharray: 1400,
            strokeDashoffset: 1400,
            animation: '$auditChartLineDraw 1150ms ease-out 260ms both',
        },
        '& .recharts-active-dot': {
            animation: '$auditChartFadeIn 360ms ease-out 900ms both',
        },
    },
    insightsCompactGrid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.85fr) minmax(320px, 1fr)',
        gap: '10px',
        margin: '12px 12px 0',
        '& $chartCard': {
            margin: 0,
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
    trendChartCard: {
        margin: 0,
    },
    moduleChartCard: {
        margin: 0,
    },
    donutChartBody: {
        display: 'grid',
        gridTemplateColumns: 'minmax(180px, 0.82fr) minmax(180px, 1fr)',
        alignItems: 'center',
        gap: '10px',
        minHeight: '184px',
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
        },
    },
    donutChart: {
        height: '180px',
        minWidth: 0,
    },
    donutChartAnimated: {
        '& .recharts-pie-sector path': {
            opacity: 0,
            transform: 'scale(0.86)',
            transformBox: 'fill-box',
            transformOrigin: 'center',
            animation: '$auditDonutIn 720ms ease-out both',
        },
        '& .recharts-pie-sector:nth-of-type(1) path': {
            animationDelay: '180ms',
        },
        '& .recharts-pie-sector:nth-of-type(2) path': {
            animationDelay: '240ms',
        },
        '& .recharts-pie-sector:nth-of-type(3) path': {
            animationDelay: '300ms',
        },
        '& .recharts-pie-sector:nth-of-type(4) path': {
            animationDelay: '360ms',
        },
        '& .recharts-pie-sector:nth-of-type(5) path': {
            animationDelay: '420ms',
        },
        '& .recharts-pie-sector:nth-of-type(6) path': {
            animationDelay: '480ms',
        },
    },
    moduleLegend: {
        display: 'flex',
        flexDirection: 'column',
        gap: '7px',
        paddingRight: '2px',
    },
    legendAnimated: {
        animation: '$auditChartFadeIn 520ms ease-out 720ms both',
    },
    legendRow: {
        display: 'grid',
        gridTemplateColumns: '10px minmax(0, 1fr) auto',
        alignItems: 'center',
        gap: '7px',
        color: '#526274',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '15px',
    },
    legendDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        display: 'inline-block',
    },
    legendName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    legendValue: {
        color: '#142133',
        fontWeight: 800,
    },
    '@media (prefers-reduced-motion: reduce)': {
        '*': {
            animationDuration: '0.001ms !important',
            animationDelay: '0ms !important',
            transitionDuration: '0.001ms !important',
        },
        '$lineChartAnimated .recharts-line-curve': {
            strokeDashoffset: '0 !important',
        },
        '$donutChartAnimated .recharts-pie-sector path': {
            opacity: '1 !important',
            transform: 'none !important',
        },
    },
    sessionsSection: {
        marginTop: '14px',
        background: '#EAF8FF',
        border: '1px solid #BDE2F1',
        borderRadius: '18px',
        overflow: 'hidden',
        paddingBottom: '12px',
    },
    sessionsHeader: {
        minHeight: '40px',
        background: '#DDF4FF',
        borderBottom: '1px solid #C5E4F1',
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        padding: '9px 16px',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            flexWrap: 'wrap',
        },
    },
    sessionsHeaderIcon: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: '#1B93B0',
        color: '#FFFFFF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    sessionsTitle: {
        color: '#0987A8',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 800,
        lineHeight: '18px',
    },
    sessionsSubtitle: {
        color: '#6A7A8D',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            paddingLeft: '31px',
        },
    },
    dateGroupCard: {
        background: '#FFFFFF',
        border: '1px solid #D4E3EC',
        borderRadius: '0 0 14px 14px',
        margin: '12px 12px 0',
        overflow: 'hidden',
        boxShadow: '0 1px 0 rgba(15, 35, 56, 0.02)',
        '&:first-of-type': {
            marginTop: '12px',
        },
    },
    dateGroupHeader: {
        minHeight: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '6px 12px',
        '&.blue': {
            background: '#DDF2FF',
            color: '#0672B7',
        },
        '&.teal': {
            background: '#DDF6F3',
            color: '#0B8C87',
        },
        '&.purple': {
            background: '#ECEBFF',
            color: '#6557C9',
        },
        '&.green': {
            background: '#DDF8E8',
            color: '#168B4E',
        },
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
        },
    },
    dateGroupTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        '& .MuiSvgIcon-root': {
            fontSize: '15px',
        },
        '& p': {
            fontFamily: 'Lato',
            fontSize: '13px',
            fontWeight: 800,
            lineHeight: '17px',
        },
    },
    dateGroupStats: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        color: '#516174',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        '& strong': {
            color: '#142133',
            fontWeight: 800,
        },
        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
            gap: '6px 12px',
            whiteSpace: 'normal',
        },
    },
    auditGrid: {
        boxSizing: 'border-box',
        maxWidth: '100%',
        overflow: 'hidden',
        '& .custom-grid': {
            background: '#FFFFFF',
            borderRadius: 0,
            boxSizing: 'border-box',
            maxWidth: '100%',
            overflow: 'hidden',
            padding: '0 !important',
        },
        '& .ant-table': {
            color: '#142133',
            fontFamily: 'Lato',
            fontSize: '13px',
            lineHeight: '17px',
            maxWidth: '100%',
            overflowX: 'auto',
        },
        '& .ant-table table': {
            minWidth: '920px',
        },
        '& .ant-table-thead > tr > th': {
            background: '#F8FAFC',
            borderBottom: '1px solid #D6E0E8',
            color: '#5D6A7C',
            fontFamily: 'Lato',
            fontSize: '11px',
            fontWeight: '800 !important',
            lineHeight: '14px',
            padding: '8px 12px !important',
            textAlign: 'left',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            whiteSpace: 'nowrap',
        },
        '& .ant-table-tbody > tr > td': {
            borderBottom: '1px solid #E4EAF0',
            color: '#142133',
            fontFamily: 'Lato',
            fontSize: '13px',
            fontWeight: 500,
            lineHeight: '17px',
            padding: '8px 12px !important',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
        },
        '& .ant-table-tbody > tr:last-child > td': {
            borderBottom: 'none',
        },
        '& .ant-table-tbody > tr.ant-table-row:hover > td': {
            background: '#F8FBFE',
        },
        '& .ant-table-pagination': {
            margin: '12px 12px 10px',
            paddingBottom: 0,
        },
        '& .ant-pagination-options': {
            marginLeft: '8px',
        },
        '&.session .ant-table table': {
            minWidth: '920px',
        },
    },
    lineHistoryGrid: {
        overflowX: 'auto',
        '& .ant-table': {
            overflowX: 'auto',
        },
        '& .ant-table table': {
            minWidth: '880px',
            tableLayout: 'fixed',
        },
        '& .ant-table-thead > tr > th': {
            padding: '8px 9px !important',
        },
        '& .ant-table-tbody > tr > td': {
            overflow: 'hidden',
            padding: '8px 9px !important',
            textOverflow: 'ellipsis',
        },
        '& .width120': {
            minWidth: '112px',
            width: '112px',
        },
        '& .width140': {
            minWidth: '124px',
            width: '124px',
        },
        '& .width150': {
            minWidth: '140px',
            width: '140px',
        },
        '& .width170': {
            minWidth: '154px',
            width: '154px',
        },
    },
    adminCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        whiteSpace: 'nowrap',
    },
    adminAvatar: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        color: '#FFFFFF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontFamily: 'Lato',
        fontSize: '10px',
        fontWeight: 800,
        '&.blue': {
            background: '#1578B9',
        },
        '&.purple': {
            background: '#665ACD',
        },
        '&.teal': {
            background: '#26999C',
        },
        '&.orange': {
            background: '#D17B37',
        },
    },
    deviceCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        whiteSpace: 'nowrap',
        '& .MuiSvgIcon-root': {
            color: '#5E7084',
            fontSize: '14px',
        },
    },
    sessionsFooter: {
        color: '#6C7D90',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        padding: '12px 16px 2px',
    },
    detailSection: {
        marginTop: '16px',
        borderRadius: '18px',
        overflow: 'hidden',
        border: '1px solid',
        boxSizing: 'border-box',
        maxWidth: '100%',
        paddingBottom: '13px',
        '&.line': {
            background: '#ECFAF1',
            borderColor: '#BDE8CA',
            '& $detailHeader': {
                background: '#DCF8E7',
                borderBottomColor: '#BDE8CA',
            },
            '& $detailHeaderIcon': {
                background: '#258B56',
            },
            '& $detailTitle': {
                color: '#1C844D',
            },
        },
        '&.payment': {
            background: '#FFF0F7',
            borderColor: '#F2C9DD',
            '& $detailHeader': {
                background: '#FCE4F0',
                borderBottomColor: '#F2C9DD',
            },
            '& $detailHeaderIcon': {
                background: '#B46191',
            },
            '& $detailTitle': {
                color: '#A64D7D',
            },
        },
        '&.profile': {
            background: '#EEF8FF',
            borderColor: '#BFDFF4',
            '& $detailHeader': {
                background: '#DFF2FF',
                borderBottomColor: '#BFDFF4',
            },
            '& $detailHeaderIcon': {
                background: '#1D84C6',
            },
            '& $detailTitle': {
                color: '#1376B3',
            },
        },
        '&.fullLog': {
            background: '#F1F7FC',
            borderColor: '#CCDCE8',
            '& $detailHeader': {
                background: '#E3EEF8',
                borderBottomColor: '#CCDCE8',
            },
            '& $detailHeaderIcon': {
                background: '#183A62',
            },
            '& $detailTitle': {
                color: '#183A62',
            },
        },
        '&.moduleSummary': {
            background: '#EFFBFA',
            borderColor: 'transparent',
            boxShadow: 'none',
            '& $detailHeader': {
                background: '#DDF6F4',
                borderBottomColor: '#C6E6E2',
            },
            '& $detailHeaderIcon': {
                background: '#249A9C',
            },
            '& $detailTitle': {
                color: '#118987',
            },
        },
        '&.userSummary': {
            background: '#F0F1FF',
            borderColor: 'transparent',
            boxShadow: 'none',
            '& $detailHeader': {
                background: '#E7E8FF',
                borderBottomColor: '#D7DAFF',
            },
            '& $detailHeaderIcon': {
                background: '#6758C9',
            },
            '& $detailTitle': {
                color: '#5E55C8',
            },
        },
    },
    detailHeader: {
        minHeight: '40px',
        borderBottom: '1px solid',
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        padding: '9px 16px',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            flexWrap: 'wrap',
        },
    },
    detailHeaderIcon: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        color: '#FFFFFF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    detailTitle: {
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 800,
        lineHeight: '18px',
    },
    detailSubtitle: {
        color: '#68798B',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            paddingLeft: '31px',
        },
    },
    detailHeaderCount: {
        color: '#5E7084',
        fontFamily: 'Lato',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '16px',
        marginLeft: 'auto',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '31px',
            width: '100%',
        },
    },
    detailTableCard: {
        background: '#FFFFFF',
        border: '1px solid #D4E3EC',
        borderRadius: '14px',
        boxSizing: 'border-box',
        maxWidth: 'calc(100% - 24px)',
        margin: '12px 12px 0',
        overflow: 'hidden',
    },
    summaryAuditGrid: {
        '& .custom-grid': {
            borderRadius: '14px',
        },
        '& .ant-table': {
            borderRadius: '14px',
            overflow: 'hidden',
        },
        '& .ant-table table': {
            border: '0 !important',
            minWidth: '1000px',
        },
        '& .ant-table-container': {
            borderRadius: '14px',
        },
        '& .ant-table-thead > tr > th': {
            background: '#F7FAFD !important',
            borderBottom: '1px solid #D8E3EC !important',
            color: '#5C6B7D',
            fontSize: '11px',
            lineHeight: '14px',
            padding: '7px 10px !important',
        },
        '& .ant-table-tbody > tr > td': {
            background: '#FFFFFF !important',
            borderBottom: '1px solid #E2E9EF',
            color: '#102033',
            fontSize: '13px',
            lineHeight: '18px',
            padding: '8px 10px !important',
        },
        '& .ant-table-tbody > tr:last-child > td': {
            borderBottom: 'none',
        },
        '& .ant-table-tbody > tr.ant-table-row:hover > td': {
            background: '#FAFDFF !important',
        },
        '& .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before': {
            display: 'none',
        },
    },
    moduleLoadingText: {
        color: '#5D6A7C',
        fontFamily: 'Lato',
        fontSize: '13px',
        fontWeight: 700,
        lineHeight: '18px',
        padding: '18px 14px',
        textAlign: 'center',
    },
    moduleNameCell: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        color: '#102033',
        fontWeight: 700,
        whiteSpace: 'nowrap',
    },
    moduleNameIcon: {
        width: '14px',
        height: '14px',
        color: '#249A9C',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '14px',
        },
    },
    strongNumber: {
        fontWeight: '800 !important',
    },
    monoText: {
        color: '#526274',
        fontFamily: 'Consolas, Monaco, "Courier New", monospace',
        fontSize: '12px',
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
    },
    compactMonoText: {
        color: '#526274',
        display: 'inline-block',
        fontFamily: 'Consolas, Monaco, "Courier New", monospace',
        fontSize: '11px',
        letterSpacing: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        verticalAlign: 'bottom',
        whiteSpace: 'nowrap',
    },
    mutedText: {
        color: '#657689',
        whiteSpace: 'nowrap',
    },
    activityBadge: {
        borderRadius: '999px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Lato',
        fontSize: '11px',
        fontWeight: 800,
        lineHeight: '14px',
        minHeight: '22px',
        padding: '4px 9px',
        whiteSpace: 'nowrap',
    },
    activityBadgeSwap: {
        background: '#E1F5F4',
        border: '1px solid #B9E5E2',
        color: '#137C7B',
    },
    activityBadgeStatus: {
        background: '#E8F7ED',
        border: '1px solid #BFE7CD',
        color: '#1C844D',
    },
    activityBadgeChange: {
        background: '#F0F1FF',
        border: '1px solid #D7DAFF',
        color: '#5E55C8',
    },
    truncatedText: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        verticalAlign: 'bottom',
        whiteSpace: 'nowrap',
    },
}));
